const Classnames = {
  Opened: '-opened',
  Hidden: 'hidden',
};

const init = () => {
  const menu = document.getElementById('navigation-menu');
  const openTriggers = [...document.querySelectorAll('[data-navigation-menu="open"]')];
  const closeTrigger = document.querySelector('[data-navigation-menu="close"]');
  const backdrop = document.getElementById('navigation-menu-backdrop');

  if (!menu || !openTriggers.length || !closeTrigger) return;

  const closeMenu = () => {
    menu.classList.remove(Classnames.Opened);
    backdrop?.classList.add(Classnames.Hidden)
    backdrop?.removeEventListener('click', closeMenu);
    if (window.isTouch) {
      document.body.style.overflow = 'initial';
    }
  }

  const openMenu = () => {
    menu.classList.add(Classnames.Opened);
    backdrop?.classList.remove(Classnames.Hidden);
    backdrop.addEventListener('click', closeMenu);
    if (window.isTouch) {
      document.body.style.overflow = 'hidden';
    }
  }

  openTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      if (menu.classList.contains(Classnames.Opened)) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  })
  closeTrigger.addEventListener('click', closeMenu);
};

init();
